"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithdrawSwitch = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../../../../hooks");
var _Switch = require("../Switch");
var _DisableModal = require("./DisableModal");
var _reactI18next = require("react-i18next");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var WithdrawSwitch = function WithdrawSwitch() {
  var _useToggle = (0, _hooks.useToggle)(false),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    modalOpened = _useToggle2[0],
    toggleModalOpened = _useToggle2[1];
  var _useWithdraw2faSwitch = (0, _hooks.useWithdraw2faSwitch)(),
    checked = _useWithdraw2faSwitch.checked,
    disabled = _useWithdraw2faSwitch.disabled,
    enableForbidden = _useWithdraw2faSwitch.enableForbidden,
    onChange = _useWithdraw2faSwitch.onChange;
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  var toggle = function toggle() {
    onChange();
    toggleModalOpened();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Switch.Switch, {
    title: t('withdraw2fa.title'),
    subtitle: t('withdraw2fa.subtitle'),
    inputProps: {
      checked: checked,
      disabled: disabled,
      onChange: toggle
    },
    isLastChecked: false,
    tooltipText: enableForbidden ? t('email2faEnableForbidden') : undefined
  }), modalOpened && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DisableModal.DisableModal, {
    toggle: toggle,
    isOpen: checked
  })));
};
exports.WithdrawSwitch = WithdrawSwitch;